import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";

export const LessonNameEditor = ({ setNameEditMode }) => {
  const { register } = useFormContext();
  return (
    <input
      className="placeholder:text-light w-full text-2xl font-bold leading-8 placeholder:opacity-100"
      autoFocus
      {...register("name", {
        onBlur: () => setNameEditMode(false),
        shouldUnregister: false,
      })}
    />
  );
};

LessonNameEditor.propTypes = {
  setNameEditMode: PropTypes.func.isRequired,
};
